export {
  LessonPageHeaderTexts,
  type LessonPageHeaderTextsVariant,
} from "#lesson-page-header-texts";
export { useLessonPageLevelSurfaceTexts } from "#use-lesson-page-level-surface-texts";
